import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import EditTextLibraryTextRuleForm from '../components/EditTextLibraryTextRuleForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import qs from 'qs';
import { Link } from 'react-router-dom';

import './EditTextLibraryTextRule.css';

class EditTextLibraryTextRule extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rule: { description: '', type_id: 0 },
            rulegroup: { uuid: '' },
            text: { heading: '', uuid: '' },
            ruleTypes: [],
            attributes: []
        };
    }

    componentDidMount() {
        this.loadTextFromServer();
        this.loadTextRuleGroupsFromServer();
    }

    loadTextFromServer() {
        const { textUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/textlibrarytext/${textUUID}`, {})
            .then(function(response) {
                self.setState({ text: response.data.text });
                self.loadOrganisationInformation();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });

                const parsed = qs.parse(
                    self.props.location.search.substring(1)
                );
                const rel = parsed.rel;
                if (rel === 'player') {
                    self.loadPlayerFromServer();
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPlayerFromServer() {
        var self = this;
        const { playerUUID } = this.props.match.params;

        axios
            .get(`${config.baseURL}/players/${playerUUID}`, {})
            .then(function(response) {
                self.setState({
                    player_name: response.data.player.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadTextRuleGroupsFromServer() {
        const { textUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/textlibrarytext/${textUUID}/rulegroups`, {})
            .then(function(response) {
                if (
                    response.data.rulegroups &&
                    response.data.rulegroups.length > 0
                ) {
                    self.setState(
                        { rulegroup: response.data.rulegroups[0] },
                        () => {
                            self.loadRuleTypesFromServer();
                        }
                    );
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationAttributesFromServer() {
        const {
            uuid,
            playerUUID,
            pageUUID,
            snippetUUID,
            textUUID
        } = this.props.match.params;

        var self = this;
        axios
            .get(`${config.baseURL}/organisations/${uuid}/attributes`, {
                params: {
                    all: true
                }
            })
            .then(function(response) {
                self.setState({
                    attributes: response.data.attributes
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadRuleTypesFromServer() {
        var self = this;
        axios
            .get(`${config.baseURL}/ruletypes`, {
                params: {
                    all: true
                }
            })
            .then(function(response) {
                self.setState({
                    ruleTypes: response.data.ruleTypes
                });
                self.loadRuleFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadRuleFromServer() {
        const { ruleUUID, textUUID } = this.props.match.params;

        var self = this;
        axios
            .get(
                `${config.baseURL}/textlibrarytext/${textUUID}/rulegroups/${
                    this.state.rulegroup.uuid
                }/rules/${ruleUUID}`,
                {}
            )

            .then(function(response) {
                self.setState({ rule: response.data.rule });
                self.loadOrganisationAttributesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        const { t } = this.props;
        const {
            uuid,
            playerUUID,
            pageUUID,
            snippetUUID,
            textUUID
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t(
            'EditTextLibraryTextRule.title'
        )}`;

        return (
            <div className="EditTextLibraryTextRule">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('EditTextLibraryTextRule.title')}
                                    {' - "'}
                                    {this.state.text.heading}
                                    {'" '}
                                    {rel === 'player' ? (
                                        <small>
                                            {this.state.player_name}{' '}
                                            <small
                                                style={{
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {this.state.organisation_name}
                                            </small>
                                        </small>
                                    ) : (
                                        <small>
                                            {this.state.organisation_name}
                                        </small>
                                    )}
                                </h1>
                                <ol className="breadcrumb">
                                    {rel === 'player' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players`}
                                                >
                                                    {t(
                                                        'SideNavigation.players'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}`}
                                                >
                                                    {t(
                                                        'OrganisationPlayer.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/`}
                                                >
                                                    {t('SideNavigation.pages')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}?rel=player`}
                                                >
                                                    {' '}
                                                    {t('Page.title')}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fa fa-font" />
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}?rel=player`}
                                                >
                                                    {' '}
                                                    {t('TextLibrarySnippet.title')}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}/texts/${textUUID}/rules?rel=player`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-pencil-alt" />{' '}
                                                {t('EditTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}

                                    {rel === 'snippet' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/snippets`}
                                                >
                                                    {' '}
                                                    {t(
                                                        'SideNavigation.globalsnippets'
                                                    )}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fa fa-font" />
                                                <Link
                                                    to={`/organisations/${uuid}/textlibrarysnippets/${snippetUUID}?rel=snippet`}
                                                >
                                                    {' '}
                                                    {t('TextLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibrarysnippets/${snippetUUID}/texts/${textUUID}/rules?rel=snippet`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-pencil-alt" />{' '}
                                                {t('EditTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                    {rel === 'page' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages`}
                                                >
                                                    {t(
                                                        'SideNavigation.globalpages'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}?rel=page`}
                                                >
                                                    {t('Page.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-font" />
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}?rel=page`}
                                                >
                                                    {' '}
                                                    {t('TextLibrarySnippet.title')}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}/texts/${textUUID}/rules?rel=page`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-pencil-alt" />{' '}
                                                {t('EditTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                </ol>

                                <PlainPanel>
                                    <EditTextLibraryTextRuleForm
                                        rule={this.state.rule}
                                        ruleTypes={this.state.ruleTypes}
                                        attributes={this.state.attributes}
                                        ruleGroupUUID={
                                            this.state.rulegroup.uuid
                                        }
                                        textUUID={textUUID}
                                    />
                                </PlainPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(EditTextLibraryTextRule);
